export const hokuyoCompanyCode = "HPo6wkyuze"